import { render, staticRenderFns } from "./ServiceRequestList.vue?vue&type=template&id=c38b840c&"
import script from "./ServiceRequestList.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports